import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { BD_FOOTER_OPTIONS_DEFAULT, BdFooterOptions } from './footer.options';
import { BdUserConsentCookieResetLinkComponent } from './cookie-reset-link/cookie-reset-link.component';

@Component({
  selector: 'bd-footer',
  template: `
    <div class="bd-footer-popover">
      <div class="bd-footer-popover__title">Rechtliches</div>
      <ul class="bd-footer-popover__list">
        @if (options().privacy.enabled) {
          <li>
            <a [href]="options().privacy.link" target="_blank" rel="noopener"
              >Datenschutz</a
            >
          </li>
        }
        @if (options().siteNotice.enabled) {
          <li>
            <a [href]="options().siteNotice.link" target="_blank" rel="noopener"
              >Impressum</a
            >
          </li>
        }
        <li>
          <!-- Generated into every app's build output by tools/third-party-licenses; static, no login. -->
          <a
            rel="nofollow noopener"
            target="_blank"
            href="/third-party-licenses.html"
            >Drittanbieter-Lizenzen</a
          >
        </li>
        <li>
          <bd-user-cookie-reset-link></bd-user-cookie-reset-link>
        </li>
        @if (options().documentation.enabled) {
          <li>
            <a
              [href]="options().documentation.link"
              target="_blank"
              rel="noopener"
              >Hilfeseiten</a
            >
          </li>
        }
        @if (options().status.enabled) {
          <li>
            <a [href]="options().status.link" target="_blank" rel="noopener"
              >Status</a
            >
          </li>
        }
      </ul>
    </div>
  `,
  styles: [
    `
      .bd-footer-popover {
        display: flex;
        flex-direction: column;
        gap: 4px;
        min-width: 180px;
      }

      .bd-footer-popover__title {
        font-size: 10px;
        font-weight: 600;
        letter-spacing: 0.06em;
        text-transform: uppercase;
        color: var(--p-text-muted-color);
        margin-bottom: 4px;
      }

      .bd-footer-popover__list {
        list-style: none;
        padding: 0;
        margin: 0;
        display: flex;
        flex-direction: column;
        gap: 4px;
        font-size: 12px;
        line-height: 16px;
      }

      .bd-footer-popover__list a {
        color: var(--p-text-color);
        text-decoration: none;
      }

      .bd-footer-popover__list a:hover {
        color: var(--p-primary-color);
        text-decoration: underline;
      }
    `,
  ],
  imports: [BdUserConsentCookieResetLinkComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BdAppContainerFooterComponent {
  readonly options = input<BdFooterOptions>(BD_FOOTER_OPTIONS_DEFAULT);
}
